import { useLink } from '../component-lib.esm6.js';
import { LINK_PROPS } from '../component-lib.esm2.js';

//
var script = {
  props: LINK_PROPS,
  setup(props, context) {
    const {
      id
    } = useLink(props, context);
    return {
      id
    };
  }
};
export { script as default };